import { Blockquote } from "../components/Blockquote";
import { ContactSection } from "../components/ContactSection";
import { Container } from "../components/Container";
import { FadeIn } from "../components/FadeIn";
import { GridList, GridListItem } from "../components/GridList";
import { GridPattern } from "../components/GridPattern";
import { List, ListItem } from "../components/List";
import { PageIntro } from "../components/PageIntro";
import { SectionIntro } from "../components/SectionIntro";
import { StylizedImage } from "../components/StylizedImage";
import { TagList, TagListItem } from "../components/TagList";
import imageLaptop from "../images/laptop.jpg";
import imageMeeting from "../images/meeting.jpg";
import imageWhiteboard from "../images/whiteboard.jpg";
import statue1 from "../images/statue1.jpg";
import statue2 from "../images/statue2.jpg";
import statue3 from "../images/statue3.jpg";
import statue4 from "../images/statue4.jpg";
import statue5 from "../images/statue5.jpg";
import statue6 from "../images/statue6.jpg";
import statue7 from "../images/statue7.jpg";
import statue8 from "../images/statue8.jpg";
import statue9 from "../images/statue9.jpg";
import statue10 from "../images/statue10.jpg";
import statue11 from "../images/statue11.jpg";
function Section({ title, image, children }) {
  return (
    <Container className="group/section [counter-increment:section]">
      <div className="lg:flex lg:items-center lg:justify-end lg:gap-x-8 lg:group-even/section:justify-start xl:gap-x-20">
        <div className="flex justify-center">
          <FadeIn className="w-[33.75rem] flex-none lg:w-[45rem]">
            <StylizedImage
              {...image}
              sizes="(min-width: 1024px) 41rem, 31rem"
              className="justify-center lg:justify-end lg:group-even/section:justify-start"
            />
          </FadeIn>
        </div>
        <div className="mt-12 lg:mt-0 lg:w-[37rem] lg:flex-none lg:group-even/section:order-first">
          <FadeIn>
            <div
              className="font-display text-base font-semibold before:text-neutral-300 before:content-['/_'] after:text-neutral-950 after:content-[counter(section,decimal-leading-zero)]"
              aria-hidden="true"
            />
            <h2 className="mt-2 font-display text-3xl font-medium tracking-tight text-neutral-950 sm:text-4xl">
              {title}
            </h2>
            <div className="mt-6">{children}</div>
          </FadeIn>
        </div>
      </div>
    </Container>
  );
}

function Discover() {
  return (
    <Section title="AI and Information" image={{ src: statue7 }}>
      <div className="space-y-6 text-base text-neutral-600">
        <p>
          Artificial Intelligence (AI) transforms the way we{" "}
          <strong className="font-semibold text-neutral-950">process</strong>,{" "}
          <strong className="font-semibold text-neutral-950">analyze</strong>,
          and{" "}
          <strong className="font-semibold text-neutral-950">utilize</strong>{" "}
          information by leveraging advanced technologies such as
          <strong className="font-semibold text-neutral-950">
            machine learning
          </strong>
          ,
          <strong className="font-semibold text-neutral-950">
            natural language processing (NLP)
          </strong>
          , and computer vision.
        </p>
        <p>
          These tools enable systems to handle{" "}
          <strong className="font-semibold text-neutral-950">
            large datasets
          </strong>
          , uncover patterns, and provide predictive analytics with
          unprecedented speed and accuracy. For example,{" "}
          <strong className="font-semibold text-neutral-950">AI-powered</strong>{" "}
          algorithms can sift through massive volumes of unstructured data to
          extract meaningful insights, enhancing decision-making in industries
          like healthcare, finance, and agriculture.
        </p>
        <p>
          By automating repetitive tasks and offering real-time analytics, AI
          empowers organizations to operate more efficiently and innovate
          faster.
        </p>
      </div>

      <h3 className="mt-12 font-display text-base font-semibold text-neutral-950">
        Included in this phase
      </h3>
      <TagList className="mt-4">
        <TagListItem>Data Insights</TagListItem>
        <TagListItem>Decision-making</TagListItem>
        <TagListItem>Machine Learning</TagListItem>
        <TagListItem>Real-time Analytics</TagListItem>
        <TagListItem>Predictive Analytics</TagListItem>
        <TagListItem>Large Language Model</TagListItem>
      </TagList>
    </Section>
  );
}

function Build() {
  return (
    <Section title="NextGen Utilty" image={{ src: statue9 }}>
      <div className="space-y-6 text-base text-neutral-600">
        <p>
          Next-generation utility solutions focus on modernizing infrastructure
          with technologies like smart grids, Internet of Things (IoT), and
          predictive analytics. These advancements enable real-time monitoring
          of energy consumption, automation of grid operations, and proactive
          maintenance to prevent outages.
        </p>
        <p>
          By integrating renewable energy sources and optimizing resource
          management, NextGen utilities ensure efficiency, sustainability, and
          reliability in service delivery.
        </p>
        <p>
          This technological evolution supports smarter cities and contributes
          to a greener future.
        </p>
      </div>

      {/* <Blockquote
        author={{ name: "Debra Fiscal", role: "CEO of Unseal" }}
        className="mt-12"
      >
        Studio were so regular with their progress updates we almost began to
        think they were automated!
      </Blockquote> */}
      <h3 className="mt-12 font-display text-base font-semibold text-neutral-950">
        Included in this phase
      </h3>
      <TagList className="mt-4">
        <TagListItem>IoT</TagListItem>
        <TagListItem>Smart Grids</TagListItem>
        <TagListItem>Real-time Monitoring</TagListItem>
        <TagListItem>Automation</TagListItem>
        <TagListItem>Resource Optimization</TagListItem>
        <TagListItem>Predictive Analytics</TagListItem>
      </TagList>
    </Section>
  );
}

function Deliver() {
  return (
    <Section title="Smart Agriculture" image={{ src: statue4 }}>
      <div className="space-y-6 text-base text-neutral-600">
        <p>
          Smart agriculture integrates advanced technologies like Internet of
          Things (IoT), artificial intelligence (AI), and data analytics to
          revolutionize farming practices.
        </p>
        <p>
          By using tools such as soil sensors, weather monitoring systems, and
          automated irrigation controllers, farmers can collect real-time data
          and optimize their resource use. These technologies enhance crop
          yields, reduce water and energy consumption, and support sustainable
          agricultural practices.
        </p>
        <p>
          Smart agriculture empowers farmers with actionable insights, enabling
          precise decision-making and improving overall productivity.
        </p>
      </div>
      {/* <List className="mt-8">
        <ListItem title="Testing">
          Our projects always have 100% test coverage, which would be impressive
          if our tests weren’t as porous as a sieve.
        </ListItem>
        <ListItem title="Infrastructure">
          To ensure reliability we only use the best Digital Ocean droplets that
          $4 a month can buy.
        </ListItem>
        <ListItem title="Support">
          Because we hold the API keys for every critical service your business
          uses, you can expect a lifetime of support, and invoices, from us.
        </ListItem>
      </List> */}
      <h3 className="mt-12 font-display text-base font-semibold text-neutral-950">
        Included in this phase
      </h3>
      <TagList className="mt-4">
        <TagListItem>IoT</TagListItem>
        <TagListItem>Data Analytics</TagListItem>
        <TagListItem>Sensors</TagListItem>
        <TagListItem>Monitoring</TagListItem>
        <TagListItem>Automated Irrigation</TagListItem>
        <TagListItem>Real-time Data</TagListItem>
      </TagList>
    </Section>
  );
}

function FieldData() {
  return (
    <Section title="Field Data" image={{ src: statue5 }}>
      <div className="space-y-6 text-base text-neutral-600">
        <p>
          Field data collection relies on IoT devices, remote sensors, and
          cloud-based platforms to capture real-world information from specific
          locations.
        </p>
        <p>
          This data provides real-time insights into environmental and
          operational variables such as soil moisture, temperature, and
          equipment performance. By analyzing field data with AI-powered tools,
          industries can improve resource efficiency, monitor trends, and
          optimize decision-making processes. It is crucial for applications in
          agriculture, environmental monitoring, and smart infrastructure
          management.
        </p>
        <p>
          It is crucial for applications in agriculture, environmental
          monitoring, and smart infrastructure management.
        </p>
      </div>

      {/* <Blockquote
        author={{ name: "Debra Fiscal", role: "CEO of Unseal" }}
        className="mt-12"
      >
        Studio were so regular with their progress updates we almost began to
        think they were automated!
      </Blockquote> */}
      <h3 className="mt-12 font-display text-base font-semibold text-neutral-950">
        Included in this phase
      </h3>
      <TagList className="mt-4">
        <TagListItem>Cloud Platforms</TagListItem>
        <TagListItem>Environmental Monitoring</TagListItem>
        <TagListItem>Resource Efficiency</TagListItem>
        <TagListItem>Smart Infrastructure</TagListItem>
        <TagListItem>Remote Sensors</TagListItem>
        <TagListItem>Real-time Insights</TagListItem>
      </TagList>
    </Section>
  );
}

function Values() {
  return (
    <div className="relative mt-24 pt-24 sm:mt-32 sm:pt-32 lg:mt-40 lg:pt-40">
      <div className="absolute inset-x-0 top-0 -z-10 h-[884px] overflow-hidden rounded-t-4xl bg-gradient-to-b from-neutral-50">
        <GridPattern
          className="absolute inset-0 h-full w-full fill-neutral-100 stroke-neutral-950/5 [mask-image:linear-gradient(to_bottom_left,white_40%,transparent_50%)]"
          yOffset={-270}
        />
      </div>

      <SectionIntro
        eyebrow="Our values"
        title="Balancing reliability and innovation"
      >
        <p>
          We strive to stay at the forefront of emerging trends and
          technologies, while completely ignoring them and forking that old
          Rails project we feel comfortable using. We stand by our core values
          to justify that decision.
        </p>
      </SectionIntro>

      <Container className="mt-24">
        <GridList>
          <GridListItem title="Meticulous">
            The first part of any partnership is getting our designer to put
            your logo in our template. The second step is getting them to do the
            colors.
          </GridListItem>
          <GridListItem title="Efficient">
            We pride ourselves on never missing a deadline which is easy because
            most of the work was done years ago.
          </GridListItem>
          <GridListItem title="Adaptable">
            Every business has unique needs and our greatest challenge is
            shoe-horning those needs into something we already built.
          </GridListItem>
          <GridListItem title="Honest">
            We are transparent about all of our processes, banking on the simple
            fact our clients never actually read anything.
          </GridListItem>
          <GridListItem title="Loyal">
            We foster long-term relationships with our clients that go beyond
            just delivering a product, allowing us to invoice them for decades.
          </GridListItem>
          <GridListItem title="Innovative">
            The technological landscape is always evolving and so are we. We are
            constantly on the lookout for new open source projects to clone.
          </GridListItem>
        </GridList>
      </Container>
    </div>
  );
}

export const metadata = {
  title: "Our Process",
  description:
    "We believe in efficiency and maximizing our resources to provide the best value to our clients.",
};

export default function Process() {
  window.scrollTo(0, 0);
  return (
    <>
      <PageIntro eyebrow="Our services" title="What we are working on">
        <p>
          By integrating cutting-edge technologies, we aim to optimize resource
          use, enhance efficiency, and provide actionable insights across
          various industries.
        </p>
      </PageIntro>

      <div className="mt-24 space-y-24 [counter-reset:section] sm:mt-32 sm:space-y-32 lg:mt-40 lg:space-y-40">
        <Discover />
        <Build />
        <Deliver />
        <FieldData />
      </div>

      <Values />

      <ContactSection />
    </>
  );
}
